<ng-template #desktopBidTemplate let-bid="bid" let-idx="idx">
    <ng-container *ngIf="idx == 0">
      <div class="d-none d-lg-flex col-lg-12 auction__header-table">
        <div class="col-6 d-flex">
          <div class="d-flex flex-column w-100 justify-content-center">
            <div class="caption px-2 text-left no-wrap">Rank</div>
          </div>
        </div>
        <div class="col-2 d-flex align-items-start">
          <div class="d-flex flex-column justify-content-center">
            <div class="caption px-2 text-center no-wrap">Current Bid</div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-start">
          <div class="d-flex flex-column justify-content-center">
            <div class="caption px-2 text-center no-wrap">Your Bid</div>
          </div>
        </div>
        <div class="col-3 d-flex justify-content-center"></div>
      </div>
    </ng-container>

    <div class="d-none d-lg-flex col-lg-12 mx-0 mb-4">
      <ng-container *ngIf="selectedBidId === bid.id else defaultState">
        <div class="row auction-item-line mb-4 w-100" [ngClass]="{'selected': !!selectedBidId}">
          <ng-container [ngTemplateOutlet]="desktopAuctionItemRowPart" [ngTemplateOutletContext]="getTemplateOutletContex(bid, idx)"></ng-container>

          <div class="col-6 flex-column justify-content-between">
            <div [ngClass]="swtcherDisabled(bid) ? 'justify-content-end' : 'justify-content-between' "  class="d-flex align-items-center mb-2">
              <app-bid-type-switcher [isChecked]="selectedBidType" [ngClass]="swtcherDisabled(bid) ? 'd-none' : '' " (onChangeBidType)="changeBidType($event, bid)"></app-bid-type-switcher>

              <input
                currencyMask
                type="text"
                [formControl]="currentAmountControl"
                class="amountInput"
              />
            </div>
            <div class="d-flex w-100 justify-content-between mb-3" [ngClass]="swtcherDisabled(bid) ? 'text-right' : '' ">
              <div class="caption w-50" [ngClass]="currentAmountControl.value < minBidAmount || currentAmountControl.value > AMOUNT_LIMIT.GLOBAL_MAX ? 'w-50' : 'w-100'" style="color: #8C8C8C">{{ helpText }} - {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
              <div class="mat-error w-50" *ngIf="currentAmountControl.value < minBidAmount"> Must be more than or equal to {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}} </div>
              <div class="mat-error w-50" *ngIf="currentAmountControl.value > AMOUNT_LIMIT.GLOBAL_MAX"> Amount must be less than {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }} </div>
            </div>

            <div class="d-flex justify-content-end align-items-center mt-4">
              <span *ngIf="bid.currentItemBid; else startingBid" class="subtitle-2--regular mr-3">Current bid: <span style="font-weight: 500">{{ bid.currentItemBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
              <ng-template  #startingBid>
                <span *ngIf="bid.optionInfo.minBid && !bid.optionInfo.buyItNowOnlyItem" class="subtitle-2--regular mr-3">Starting bid: <span style="font-weight: 500">{{ bid.optionInfo.minBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
              </ng-template>
              <button
                class="donor-flow-button donor-flow-button--outline donor-flow-button--sm mr-2" style="width: 100px; min-width: 100px"
                (click)="onDismiss()"
                [disabled]="buttonDisabled(bid)"
              >Cancel</button>
              <button
                class="donor-flow-button donor-flow-button--sm" style="width: 100px; min-width: 100px"
                (click)="onClickConfirm(bid)"
                [disabled]="confirmButtonDisabled(bid)"
              >Confirm</button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #defaultState>
        <div (click)="onDismiss()" class="row auction-item-line w-100">
          <ng-container [ngTemplateOutlet]="desktopAuctionItemRowPart" [ngTemplateOutletContext]="getTemplateOutletContex(bid, idx)"></ng-container>

          <div class="col-2 d-flex">
            <div class="all-bids__box d-flex flex-column w-100">
              <div class="all-bids__box-value subtitle-2 d-flex align-items-center justify-content-center currency" [ngClass]= "bid.currentRank === 0 ? 'green-color' : 'red-color'">
                {{ bid.currentItemBid | currency:'USD':'symbol-narrow':'1.0-0'}}
              </div>
            </div>
          </div>
          <div class="col-1 d-flex">
            <div class="all-bids__box d-flex flex-column w-100">
              <div class="all-bids__box-value subtitle-2 d-flex align-items-center justify-content-center currency" >{{ bid.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
            </div>
          </div>
            <div class="col-3 d-flex flex-column align-items-end justify-content-center" style="gap: 8px;">
              <ng-container *ngIf="bid.optionInfo.status !== 1; else notAvailable">
                @if (auctionHelperService.getSoldOutBadgeStatus(campaign, bid.optionInfo)) {
                  <div class="d-flex justify-content-center flex-column h-100 w-100">
                    <div class='card__sold text-center'>
                      <span class="subtitle-2 py-1 px-4" style="border-radius: 16px;">Sold Out</span>
                    </div>
                  </div>
                }

                <button
                  *ngIf="auctionHelperService.showBidButton(campaign, bid.optionInfo)"
                  class="donor-flow-button donor-flow-button--sm"
                  (click)="openBidPopup(bid)"
                  [ngClass]="buttonClass(bid)"
                  [disabled]="buttonDisabled(bid)"
                >
                  {{getButtonText(bid)}}
                </button>

                <button
                  *ngIf="auctionHelperService.showBuyItNow(campaign, bid.optionInfo)"
                  class="donor-flow-button donor-flow-button--outline donor-flow-button--sm"
                  (click)="onBuyNowHandler(bid)"
                > Buy now - {{ bid.optionInfo.buyItNowAmount | currency:'USD':'symbol-narrow':'1.0-0' }}</button>
              </ng-container>
              <ng-template #notAvailable>
                <span class="no-available">No Longer Available</span>
              </ng-template>
            </div>
        </div>
      </ng-template>
      <hr>
    </div>
</ng-template>

<ng-template #tabletBidTemplate let-bid="bid" let-idx="idx">
  <ng-container *ngIf="idx == 0">
    <div class="col-12 auction__header-table">
      <div class="col-7 d-flex">
        <div class="d-flex flex-column w-100 justify-content-center">
          <div class="caption px-2 text-left no-wrap">Rank</div>
        </div>
      </div>
      <div class="col-1 d-flex align-items-start px-1">
        <div class="d-flex flex-column justify-content-center">
          <div class="caption px-2 text-center">Current Bid</div>
        </div>
      </div>
      <div class="col-1 d-flex align-items-start px-1">
        <div class="d-flex flex-column justify-content-center">
          <div class="caption px-2 text-center">Your Bid</div>
        </div>
      </div>
      <div class="col-2 d-flex justify-content-center"></div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="selectedBidId === bid.id else defaultState">
    <div class="row auction-item-line mb-4" [ngClass]="{'selected': !!selectedBidId}">
      <ng-container [ngTemplateOutlet]="tabletAuctionItemRowPart" [ngTemplateOutletContext]="getTemplateOutletContex(bid, idx)"></ng-container>
     <!--   Selected State   -->
     <div class="col-12 col-lg-5 flex-column justify-content-between">
       <div class="bid-wrapper mb-2">
         <app-bid-type-switcher [isChecked]="selectedBidType" [ngClass]="swtcherDisabled(bid) ? 'd-none' : '' " (onChangeBidType)="changeBidType($event, bid)"></app-bid-type-switcher>
         <div class="help-text-middle caption mt-2 mb-3" style="color: #8C8C8C">{{ helpText }} - {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
         <input
           currencyMask
           type="text"
           [formControl]="currentAmountControl"
           class="amountInput"
         />
       </div>
       <div class="d-flex w-100 justify-content-between mb-3">
         <div class="caption w-50 d-none d-lg-flex" [ngClass]="currentAmountControl.value < minBidAmount || currentAmountControl.value > AMOUNT_LIMIT.GLOBAL_MAX ? 'w-50' : 'w-100'" style="color: #8C8C8C">{{ helpText }} - {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
         <div class="mat-error w-100 w-lg-50 text-right" *ngIf="currentAmountControl.value < minBidAmount"> Must be more than or equal to {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}} </div>
         <div class="mat-error w-100 w-lg-50 text-right" *ngIf="currentAmountControl.value > AMOUNT_LIMIT.GLOBAL_MAX"> Amount must be less than {{ AMOUNT_LIMIT.GLOBAL_MAX_STR}} </div>
       </div>

       <div class="d-flex justify-content-end align-items-center">
         <span *ngIf="bid.currentItemBid; else startingBid" class="subtitle-2--regular mr-3">Current bid: <span style="font-weight: 500">{{ bid.currentItemBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
         <ng-template  #startingBid>
           <span *ngIf="bid.optionInfo.minBid && !bid.optionInfo.buyItNowOnlyItem" class="subtitle-2--regular mr-3">Starting bid: <span style="font-weight: 500">{{ bid.optionInfo.minBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
         </ng-template>

         <button
           class="donor-flow-button donor-flow-button--outline donor-flow-button--sm mr-2" style="width: 100px; min-width: 100px"
           (click)="onDismiss()"
           [disabled]="buttonDisabled(bid)"
         >Cancel</button>
         <button
           class="donor-flow-button donor-flow-button--sm" style="width: 100px; min-width: 100px"
           (click)="onClickConfirm(bid)"
           [disabled]="confirmButtonDisabled(bid)"
         >Confirm</button>
       </div>
     </div>
  </div>
  </ng-container>

  <ng-template #defaultState>
    <div (click)="onDismiss()" class="row auction-item-line">
      <ng-container [ngTemplateOutlet]="tabletAuctionItemRowPart" [ngTemplateOutletContext]="getTemplateOutletContex(bid, idx)"></ng-container>
    <div class="col-1 d-flex">
      <div class="all-bids__box d-flex flex-column w-100">
        <div class="all-bids__box-value subtitle-2
       d-flex align-items-center justify-content-center currency"
        [ngClass]= "bid.currentRank === 0 ? 'green-color' : 'red-color'"
        >{{ bid.currentItemBid | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
      </div>
    </div>
    <div class="col-1 d-flex">
      <div class="all-bids__box d-flex flex-column w-100">
        <div class="all-bids__box-value subtitle-2 d-flex align-items-center justify-content-center currency">{{ bid.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
      </div>
    </div>
        <div class="col-3 d-flex flex-column align-items-end justify-content-center" style="gap: 8px;">
          <ng-container *ngIf="bid.optionInfo.status !== 1; else notAvailable">
            @if (auctionHelperService.getSoldOutBadgeStatus(campaign, bid.optionInfo)) {
              <div class="d-flex justify-content-center flex-column h-100 w-100">
                <div class='card__sold text-center'>
                  <span class="subtitle-2 py-1 px-4" style="border-radius: 16px;">Sold Out</span>
                </div>
              </div>
            }

            <button
              *ngIf="auctionHelperService.showBidButton(campaign, bid.optionInfo)"
              class="donor-flow-button donor-flow-button--sm"
              (click)="openBidPopup(bid)"
              [ngClass]="buttonClass(bid)"
              [disabled]="buttonDisabled(bid)"
            >
                {{getButtonText(bid)}}
            </button>

            <button
              *ngIf="auctionHelperService.showBuyItNow(campaign, bid.optionInfo)"
              class="donor-flow-button donor-flow-button--outline donor-flow-button--sm"
              (click)="onBuyNowHandler(bid)"
            > Buy now - {{ bid.optionInfo.buyItNowAmount | currency:'USD':'symbol-narrow':'1.0-0' }}</button>
          </ng-container>
          <ng-template #notAvailable>
            <span class="no-available">No Longer Available</span>
          </ng-template>
        </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #mobileBidTemplate let-bid="bid">
  <ng-container *ngIf="selectedBidId === bid.id else defaultState">
    <div class="row auction-item-line-small" [ngClass]="{'selected': !!selectedBidId}">
      <div class="row py-4 mx-0" >
        <div class="col-1 d-flex mb-3">
          <div [ngClass]="getRankClass(bid)" class="subtitle-1--weight-regular d-flex align-items-center justify-content-center">{{ bid.currentRank + 1 }}</div>
        </div>
        <div class="col-4">
          <img class="w-100" [src]="getImageUrl(bid)">
        </div>

        <div class="col-7 d-flex">
          <div class="subtitle-1">{{ bid.optionInfo.name }}</div>
        </div>
      </div>
      <!--   Selected State   -->
      <div class="col-12 flex-column justify-content-between">
        <div class="bid-wrapper mb-3">
          <app-bid-type-switcher [isChecked]="selectedBidType" [ngClass]="swtcherDisabled(bid) ? 'd-none' : '' " (onChangeBidType)="changeBidType($event, bid)"></app-bid-type-switcher>
          <div class="help-text-middle caption mt-2 mb-3" style="color: #8C8C8C">{{ helpText }} - {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
          <input
            currencyMask
            type="text"
            [formControl]="currentAmountControl"
            class="amountInput mb-2"
          />
          <div class="mat-error" *ngIf="currentAmountControl.value < minBidAmount"> Must be more than or equal to {{ calculatedNextBidAmount | currency:'USD':'symbol-narrow':'1.0-0'}} </div>
          <div class="mat-error" *ngIf="currentAmountControl.value > AMOUNT_LIMIT.GLOBAL_MAX"> Amount must be less than {{ AMOUNT_LIMIT.GLOBAL_MAX_STR }} </div>
        </div>

        <div class="d-flex justify-content-end align-items-center">
          <span *ngIf="bid.currentItemBid; else startingBid" class="subtitle-2--regular mr-3">Current bid: <span style="font-weight: 500">{{ bid.currentItemBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
          <ng-template  #startingBid>
            <span *ngIf="bid.optionInfo.minBid && !bid.optionInfo.buyItNowOnlyItem" class="subtitle-2--regular mr-3">Starting bid: <span style="font-weight: 500">{{ bid.optionInfo.minBid | currency:'USD':'symbol-narrow':'1.0-0'}}</span></span>
          </ng-template>

          <button
            class="donor-flow-button donor-flow-button--outline donor-flow-button--sm mr-2" style="width: 100px; min-width: 100px"
            (click)="onDismiss()"
            [disabled]="buttonDisabled(bid)"
          >Cancel</button>

          <button
            class="donor-flow-button donor-flow-button--sm" style="width: 100px; min-width: 100px"
            (click)="onClickConfirm(bid)"
            [disabled]="confirmButtonDisabled(bid)"
          >Confirm</button>
        </div>
      </div>
    </div>

  </ng-container>
  <ng-template #defaultState>
    <div (click)="onDismiss()">
      <div class="row pt-4 mb-2 mx-0" style="border-top: 1px solid #dedede;">
        <div class="col-1 d-flex mb-3">
          <div [ngClass]="getRankClass(bid)" class="subtitle-1--weight-regular d-flex align-items-center justify-content-center">{{ bid.currentRank + 1 }}</div>
        </div>
        <div class="col-4">
          <img class="w-100" [src]="getImageUrl(bid)">
        </div>

        <div class="col-7 d-flex">
          <div class="subtitle-1">{{ bid.optionInfo.name }}</div>
        </div>
      </div>
      <div class="row mx-0 mb-3">
        <div class="col-1"></div>
        <div class="col-11 d-flex justify-content-start">
          <div class="d-flex subtitle-2--regular">Your Bid: </div>
          <div class="d-flex subtitle-2--bold">{{ bid.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</div>
        </div>
      </div>
      <div class="row mx-0">
        <div class="col-1"></div>
          <div class="col-11 d-flex justify-content-between px-0 mb-3" style="gap: 8px;">
            <ng-container *ngIf="bid.optionInfo.status !== 1; else notAvailable">
              @if (auctionHelperService.getSoldOutBadgeStatus(campaign, bid.optionInfo)) {
                <div class="d-flex justify-content-center flex-column h-100 w-100">
                  <div class='card__sold text-center'>
                    <span class="subtitle-2 py-1 px-4" style="border-radius: 16px;">Sold Out</span>
                  </div>
                </div>
              }

              <button
                class="donor-flow-button donor-flow-button--sm" style="min-width: 120px"
                *ngIf="auctionHelperService.showBidButton(campaign, bid.optionInfo)"
                (click)="openBidPopup(bid)"
                [ngClass]="buttonClass(bid)"
                [disabled]="buttonDisabled(bid)"
              >{{getButtonText(bid)}}</button>

              <button
                *ngIf="auctionHelperService.showBuyItNow(campaign, bid.optionInfo)"
                class="donor-flow-button donor-flow-button--outline donor-flow-button--sm" style="min-width: 120px"
                (click)="onBuyNowHandler(bid)"
              > Buy now - {{ bid.optionInfo.buyItNowAmount | currency:'USD':'symbol-narrow':'1.0-0' }}</button>
            </ng-container>
            <ng-template #notAvailable>
              <span class="no-available">No Longer Available</span>
            </ng-template>
          </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<div class="main-container">
  <div class="body-1">Welcome Back <span class="font-weight-bold">{{list[0]?.userInfo.name}} 👋</span></div>

  <div class="dashboard-summary">
    <div [style.background]="'url(' + getCampaignUrl() + ')'" class="background-tile"></div>
    <div class="main-info">
      <div class="row justify-content-between">
        <div class="name-wrapper mx-0 mb-4">
          <div class="headline-5--weight-regular title">{{ campaign?.name }}</div>
          <a class="subtitle-2--underline view-all-items" target="_blank" (click)="backToAuctionItems()" >View All Items</a>
        </div>

        <div class="campaign-image-small">
          <div class="campaign-image">
            <img [src]="getCampaignUrl()">
          </div>
        </div>
      </div>

      <div class="row w-100 mt-0 mt-sm-3 mt-lg-0">
        <div class="dashboard-summary-info" *ngIf="manualStatus?.auctionState">
          <div class="title subtitle-2--regular">Auction Status</div>
          <div class="value auction-status subtitle-1--weight-regular"> {{ manualStatus?.auctionState }} </div>
        </div>

        <div *ngIf="list?.length" class="dashboard-summary-info">
          <div class="title subtitle-2--regular">Your Bids</div>
          <div class="value subtitle-1--weight-regular"> {{ list?.length }} </div>
        </div>

        <div *ngIf="winningBids?.length" class="dashboard-summary-info">
          <div class="title subtitle-2--regular">Items Won</div>
          <div class="value headline-6--weight-regular"> {{ winningBids?.length }} </div>
        </div>
      </div>

      <div *ngIf="auctionControlMethod === 1" class="row w-100 mt-3">
        <div *ngIf="auctionControlMethod === 1 && auctionStatusDetails?.startingInFormat && auctionStatusDetails?.auctionStatus !== 2" class="status-message">Auction starts {{ auctionStatusDetails.startInMoreThatDay ? 'on ' : 'in ' }} {{ auctionStatusDetails?.startingInFormat }}</div>
        <div *ngIf="auctionControlMethod === 1 && !auctionStatusDetails?.isStartingIn && auctionStatusDetails?.closingInFormat && auctionStatusDetails?.auctionStatus !== 2" class="status-message">Auction ends {{ auctionStatusDetails.endInMoreThatDay ? 'on ' : 'in ' }} {{ auctionStatusDetails?.closingInFormat  }}</div>
        <div *ngIf="auctionControlMethod === 1 && auctionStatusDetails?.auctionStatus === 2" class="status-message paused">{{ manualStatus?.status}}</div>
      </div>

      <div *ngIf="auctionControlMethod === 0" class="row w-100 mt-3">
        <div *ngIf="auctionControlMethod === 0 && manualStatus?.auctionState === 'Paused'" class="status-message paused">{{ manualStatus?.status}}</div>
      </div>

      <div *ngIf="auctionControlMethod === 0" class="row w-100 mt-3">
        <div *ngIf="auctionControlMethod === 0 && manualStatus?.auctionState === 'Done'" class="status-message paused">{{ manualStatus?.status}}</div>
      </div>
    </div>
    <div class="campaign-image-wrapper">
      <div class="campaign-image">
        <img [src]="getCampaignUrl()">
      </div>
    </div>
  </div>
</div>
<div class="main-container">

  <app-featured-items *ngIf="featuredOptions.length" [items]="featuredOptions" [type]="types.featured" [quickPledge]="quickPledge" [campaign]="campaign"></app-featured-items>

  <div class="headline-6--weight-regular">Your Items</div>
  <div class="auction__subtitle subtitle-2--regular">You are ranked #1 on {{ rankedCount }} of the {{ list.length }} items you are bidding on.</div>

  <div class="row mx-0 px-0">
    <div class="col-12 col-xl-9 pr-xl-5">
        <ng-container *ngFor="let bid of list; let idx = index;">
          <ng-container [ngTemplateOutlet]="getTemplateOutlet()" [ngTemplateOutletContext]="getTemplateOutletContex(bid, idx)"></ng-container>
        </ng-container>
    </div>
  @if(isShowActivities){
    <div class="d-none d-xl-flex col-xl-3 activities">
      <div class="subtitle-1--weight-regular mb-3">Live Activity</div>

      <ng-container *ngFor="let recentActivity of recentActivities; let idx = index;">
        <div class="row activity-row" [ngClass]="{'highlight': !!isHighLight(recentActivity.id)}">
          <div class="col-1 bidder-logo">
            <img class="logo" [src]="recentActivity.imageUrl ? recentActivity.imageUrl : '/images/user_default.png'" style="height:24px;">
          </div>
          <div class="col-7 bid-title headline-8--regular"><span class="bid-amount">{{ recentActivity.amount | currency: 'USD':'symbol-narrow':'1.0-0' }}</span> bid on <span class="option-name">{{ recentActivity.optionInfo.name }} </span> by <span class="bidder-name">{{ recentActivity.userInfo.name }}</span></div>
          <div class="col-4 caption--bold"> {{ recentActivity.created | date : "shortTime"  }} / {{ recentActivity.created | date : "mediumDate"  }}  </div>
        </div>
      </ng-container>
    </div>
  }

  </div>
</div>


<!-- Template parts which reused on different places-->
<ng-template #tabletAuctionItemRowPart let-bid="bid" let-idx="idx">
  <div class="col-1 d-flex">
    <div class="all-bids__box d-flex flex-column w-100">
      <div [ngClass]="getRankClass(bid)" class="all-bids__box-value d-flex align-items-center justify-content-center rank">{{ bid.currentRank + 1 }}</div>
    </div>
  </div>
  <div class="col-6 d-flex align-items-center">
    <div class="w-100">
      <div class="bid-info">
        <div class="d-flex align-items-center">
          <img class="all-bids__image--desktop mr-3" [src]="getImageUrl(bid)" style="height:48px;">
          <div class="d-flex flex-column justify-content-center">
            <div class="subtitle-2 mb-1">{{ bid.optionInfo.name }}</div>
            <div class="caption" style="color: #8C8C8C">{{ bid.optionInfo.count - bid.optionInfo.soldCount }}x available</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<!-- Template parts which reused on different places-->
<ng-template #desktopAuctionItemRowPart let-bid="bid" let-idx="idx">
  <div class="col-1 d-flex">
    <div class="all-bids__box d-flex flex-column w-100">
      <div [ngClass]="getRankClass(bid)" class="all-bids__box-value d-flex align-items-center justify-content-center rank">{{ bid.currentRank + 1 }}</div>
    </div>
  </div>
  <div class="col-5 d-flex align-items-center">
    <div class="w-100">
      <div class="bid-info">
        <div class="d-flex align-items-center">
          <img class="all-bids__image--desktop mr-3" [src]="getImageUrl(bid)" style="height:48px;">
          <div class="d-flex flex-column justify-content-center">
            <div class="subtitle-2 mb-1">{{ bid.optionInfo.name }}</div>
            <div class="caption" style="color: #8C8C8C">{{ bid.optionInfo.count - bid.optionInfo.soldCount }}x available</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<app-mdb-toast ></app-mdb-toast>
<app-dialog></app-dialog>
